// extracted by mini-css-extract-plugin
module.exports = {"card":"AreapageSituationCardPart_card__sExIz","disabled":"AreapageSituationCardPart_disabled__SF_Na","disabledMsg":"AreapageSituationCardPart_disabledMsg__d_Ia6"};